import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useUserContext } from "../../../contexts/UserContext";
import { UserActionTypes } from "../../../contexts/reducers/userReducer";
import { RequestOtpMutation } from "../../../graphql/deliveryService/mutations/requestOtp";
import { OtpFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";

interface RequestOtpMutationProps {
  dataAction?: (data: OtpFragment) => void;
  errorAction?: (error: any) => void;
}

const useRequestOtpMutation = (props: RequestOtpMutationProps) => {
  const { t } = useTranslation();
  const { dispatchUser } = useUserContext();

  const { dataAction, errorAction } = props;

  const mutation = useMutation(RequestOtpMutation);

  const { data, error } = mutation[1];

  const OtpFragment = data?.otp.otpOutput;

  useEffect(() => {
    if (!error) return;

    errorAction && errorAction(error);
  }, [error]);

  useEffect(() => {
    if (!data || !OtpFragment) return;

    dispatchUser({
      type: UserActionTypes.SetOtpResponse,
      value: OtpFragment,
    });

    dataAction && dataAction(OtpFragment);
  }, [data]);

  return mutation;
};

export default useRequestOtpMutation;
